<template>
  <footer class="legal-footer">
    <div class="footer-content">
      <div class="footer-links">
        <a href="/impressum" class="legal-link">{{ $t('footer.imprint') }}</a>
        <span class="divider">|</span>
        <a href="/datenschutz" class="legal-link">{{ $t('footer.privacy') }}</a>
        <span class="divider">|</span>
        <a href="/agb" class="legal-link">{{ $t('footer.terms') }}</a>
        <span class="divider">|</span>
        <a href="/ki-transparenz" class="legal-link">{{ $t('footer.aiTransparency') }}</a>
        <span class="divider">|</span>
        <a href="/ai-act-image-converter" class="legal-link">{{ $t('footer.aiActImages') }}</a>
        <span class="divider">|</span>
        <a href="#" class="legal-link" @click.prevent="openCookieSettings">{{ $t('footer.cookieSettings') }}</a>
        <span class="divider">|</span>
        <a href="/learn" class="legal-link">{{ $t('footer.astrologyDice') }}</a>
      </div>
      <div class="legal-info">
        <p>{{ $t('footer.copyright') }}</p>
        <p class="address">{{ $t('footer.address') }}</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'LegalFooter',
  methods: {
    openCookieSettings() {
      window.dispatchEvent(new CustomEvent('open-cookie-settings'));
    }
  }
}
</script>

<style scoped>
.legal-footer {
  background: rgba(0, 0, 0, 0.9);
  padding: 40px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 40px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.footer-links {
  margin-bottom: 30px;
}

.legal-link {
  color: white;
  text-decoration: none;
  opacity: 0.8;
  transition: opacity 0.3s ease;
  font-size: 0.9rem;
}

.legal-link:hover {
  opacity: 1;
}

.divider {
  color: rgba(255, 255, 255, 0.3);
  margin: 0 15px;
}

.legal-info {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.6);
}

.legal-info p {
  margin: 5px 0;
}
</style>
